import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

/**
 * Item de la lista de paradas
 * @prop {function} delete Funcion para borrar el item
 * @prop {Object} parada Objeto con los datos de parada
 * @prop {Object} parada.nombre Nombre de la parada
 */
@connect((store) => ({
  userRoles: store.getIn(['user', 'roles']),
}))
class ItemList extends React.Component {
  delete = (parada) => this.props.delete(parada);
  add = (parada) => this.props.dispatch(push('/dashboard/paradas/add/' + parada.id));
  render() {
    const { parada, userRoles, crearSimilar, isSugerida } = this.props;
    let textoParada = '';
    if (!isSugerida) textoParada = parada.alias;
    else {
      if (parada.alias) textoParada = parada.alias;
      if (parada.alias && parada._usuario) textoParada += ' - ';
      if (parada._usuario) textoParada += `Sugerida por: ${parada._usuario.nombre} ${parada._usuario.apellido}`;
    }
    const paradaClick = !isSugerida ? this.add.bind(this, parada) : () => crearSimilar({ ...parada });
    return (
      <Row>
        <Col md="12">
          <MaterialUI.ListItem
            primaryText={<div onClick={paradaClick}>{textoParada}</div>}
            secondaryText={<div onClick={paradaClick}>{parada.nombre}</div>}
            rightIconButton={
              userRoles && userRoles.find((v) => v == 'admin' || v == 'devAdmin' || v == 'administrador_paradas') && !isSugerida ? (
                <MaterialUI.IconMenu
                  iconButtonElement={
                    <MaterialUI.IconButton touch={true} tooltipPosition="bottom-left">
                      <MoreVertIcon />
                    </MaterialUI.IconButton>
                  }
                >
                  <MaterialUI.MenuItem onTouchTap={this.props.delete.bind(this, parada)}>
                    <FontAwesome name="trash" className="red" /> Eliminar
                  </MaterialUI.MenuItem>
                  <MaterialUI.MenuItem onTouchTap={() => crearSimilar(parada)}>
                    <FontAwesome name="copy" className="green" /> Copiar
                  </MaterialUI.MenuItem>
                </MaterialUI.IconMenu>
              ) : (
                <MaterialUI.MenuItem onTouchTap={this.props.delete.bind(this, parada)}>
                  <FontAwesome name="trash" className="red" />
                </MaterialUI.MenuItem>
              )
            }
          />
          <MaterialUI.Divider />
        </Col>
      </Row>
    );
  }
}

ItemList.propTypes = {
  delete: PropTypes.func.isRequired,
  parada: PropTypes.object.isRequired,
};
export default ItemList;



// WEBPACK FOOTER //
// src/modules/paradas/components/itemList.js